import {AttributeLink, AttributeSetup} from '@acng/frontend-stargazer';
import {Watch} from '@acng/frontend-relativity';
import {attributeSelector} from '@acng/frontend-bounty/dom/query.js';

import {Actor} from '../../layout/context/list.js';
import {ListItem} from '../../amateurPool/service/template.js';
import {ctxPinsAvailable} from '../context/available.js';
import {byAmateur} from '../service/cache.js';

/**
 * @group DOM Attribute
 */
const name = 'pin-list';

AttributeSetup(name, (name) => {
  const watch = Watch(attributeSelector(name), ctxPinsAvailable);
  const provide = Actor();

  AttributeLink(name, (element) => {
    watch(element, (element) => {
      provide(element, async () => [], ListItem, [...byAmateur]);
    });
  });
});

export {name as PIN_LIST};
